<script>

import versao0 from '@/versao';
import Swal from "sweetalert2";


export default {

  data() {
    return {
      versao: versao0,
    }
  },

  methods: {

    abrirChamado() {
      console.log('abrirChamado')
      var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      if(isChrome) {
        console.log("Você está usando o Google Chrome");
        var isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;
        let textMens = "Necessitamos da extensáo Merlin instalada, basta acionar as teclas Command + M"
        if (isMac){
          textMens = "Necessitamos da extensáo Merlin instalada, basta acionar as teclas CTRL + M"
        }
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Assistente Inteligëncia Artificial",
          text: textMens,
          confirmButtonText: "Instalar Extensão",
          cancelButtonText: "Fechar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            window.open('https://chromewebstore.google.com/detail/merlin-1-click-access-to/camppjleccjaphfdbohjdohecfnoikec', '_blank');
          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: "Favor utilizar navegador Google Chrome para Nosso Plugin de Inteligência Artificial",
          showConfirmButton: false,
          timer: 3500
        })
      }
    },
  }

}


</script>


<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">🙏 Deus é fiel!</div>
        <div class="col-sm-6">
          <a href="javascript: void(0);" @click="abrirChamado">
            <div class="text-sm-end d-none d-sm-block">

              <i class="mdi mdi-whatsapp font-size-24"></i>
              ({{ versao }}) Suporte AI
            </div>
          </a>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
<script setup>
</script>
